import { Dialog, DialogProps } from '@mui/material';

import { ReviewForm, ReviewFormProps } from './ReviewForm';

export type ReviewDialogProps = Omit<DialogProps, 'onClose'> & ReviewFormProps;

export function ReviewDialog({
  onClose,
  userId,
  productId,
  review,
  orderId,
  isAdmin,
  ...props
}: ReviewDialogProps) {
  return (
    <Dialog
      {...props}
      PaperProps={{ sx: { minWidth: '43rem', p: 1 } }}
      scroll="body"
    >
      <ReviewForm
        userId={userId}
        productId={productId}
        orderId={orderId}
        review={review}
        isAdmin={isAdmin}
        onClose={onClose}
      />
    </Dialog>
  );
}
